import { Stack, styled } from '@mui/material';
import Header from 'components/layout/header/header';
import Sidebar from 'components/layout/Sidebar';
import { Outlet } from 'react-router-dom';

const AppWrapper = styled(Stack)({
    minHeight: '100vh',
    width: '100%',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
});
const PageWrapper = styled(Stack)({
    flexGrow: 1,
    marginTop: '6rem',
    padding: '1rem',
});

const ApplicationContainer = () => {
    return (
        <AppWrapper>
            <Header />
            <Stack flexDirection={'row'} flexGrow={1}>
                <Sidebar />
                <PageWrapper>
                    <Outlet />
                </PageWrapper>
            </Stack>
        </AppWrapper>
    );
};

export default ApplicationContainer;
